// This file was automatically generated from ptdata.letters.attachments.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.letters.attachments');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.template.ptdata.reports');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.savedAttachmentSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.entityDate) ? '<span class="el8AttachmentDate">' + (soy.$$escapeHtml(opt_data.entityDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.entityDate)) : '') + '</span>' : '', '<span class="el8AttachmentTitle">');
  if (opt_data.entityId && ! opt_data.noAttachmentLinks) {
    output.append('<a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.entityId), '">');
    el8.template.ptdata.letters.attachments._entityDescription(opt_data, output);
    output.append('</a>');
  } else if (opt_data.attachmentType == 'PatientDemog' && ! opt_data.noAttachmentLinks) {
    output.append('<a class="patient-info-trigger">');
    el8.template.ptdata.letters.attachments._entityDescription(opt_data, output);
    output.append('</a>');
  } else {
    el8.template.ptdata.letters.attachments._entityDescription(opt_data, output);
  }
  output.append('</span><span class="el8AttachmentDescription">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.summary) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.summary)) : soy.$$escapeHtml(opt_data.summary)), '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments._entityDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.entityDescription) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.entityDescription)) : soy.$$escapeHtml(opt_data.entityDescription)));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.clientGeneratedAttachmentSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.documentDate) ? '<span class="el8AttachmentDate">' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') + '</span>' : '');
  el8.template.ptdata.letters.attachments.attachmentTitle(opt_data, output);
  el8.template.ptdata.letters.attachments.attachmentDescription(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.attachmentTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.modelClass) {
    case 'Report':
    case 'VisitNote':
    case 'NonvisitNote':
    case 'Handout':
    case 'ReferralOrder':
    case 'CardiacOrder':
    case 'ImagingOrder':
    case 'LabOrder':
    case 'PulmonaryOrder':
    case 'SleepOrder':
    case 'MessageThread':
    case 'Letter':
    case 'LetterReceipt':
    case 'PrenatalFlowsheet':
      if (opt_data.noAttachmentLinks) {
        el8.template.ptdata.letters.attachments._rawTitle(opt_data, output);
      } else {
        output.append('<a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.id), '">');
        el8.template.ptdata.letters.attachments._rawTitle(opt_data, output);
        output.append('</a>');
      }
      break;
    case 'PatientDemog':
      if (opt_data.noAttachmentLinks) {
        el8.template.ptdata.letters.attachments._rawTitle(opt_data, output);
      } else {
        output.append('<a class="patient-info-trigger">');
        el8.template.ptdata.letters.attachments._rawTitle(opt_data, output);
        output.append('</a>');
      }
      break;
    case 'RefPanel':
    case 'ImmHistory':
    case 'MedsList':
    case 'CompMedsList':
    case 'WhoHeightChart':
    case 'WhoWeightChart':
    case 'WhoHcChart':
    case 'CdcHeightChart':
    case 'CdcWeightChart':
    case 'CdcBmiChart':
    case 'CdcHcChart':
      el8.template.ptdata.letters.attachments._rawTitle(opt_data, output);
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments._rawTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8AttachmentTitle">');
  el8.template.ptdata.letters.attachments.rawTitleText(opt_data, output);
  output.append('</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.rawTitleText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.modelClass) {
    case 'Report':
      output.append(soy.$$escapeHtml(opt_data.reportTypeName));
      break;
    case 'ReferralOrder':
      output.append('Referral');
      break;
    case 'CardiacOrder':
    case 'ImagingOrder':
    case 'LabOrder':
    case 'SleepOrder':
    case 'PulmonaryOrder':
      output.append((soy.$$escapeHtml(opt_data.orderType)? soy.$$escapeHtml(opt_data.orderType).capitalize() : ''), ' Order');
      break;
    case 'VisitNote':
      if (opt_data.isImportedNote) {
        el8.template.ptdata.model.note.importedVisitDescription(opt_data, output);
      } else {
        el8.template.ptdata.model.note.visitNoteDescription(opt_data, output);
      }
      break;
    case 'NonvisitNote':
      if (opt_data.isImportedNote) {
        el8.template.ptdata.model.note.importedNonvisitDescription(opt_data, output);
      } else {
        el8.template.ptdata.model.note.nonvisitNoteDescription(opt_data, output);
      }
      break;
    case 'Handout':
      output.append(soy.$$escapeHtml(opt_data.name));
      break;
    case 'RefPanel':
      output.append('Clinical Profile');
      break;
    case 'PatientDemog':
      output.append('Patient Demographics');
      break;
    case 'ImmHistory':
      output.append('Immunization History');
      break;
    case 'MedsList':
      output.append('Medications List');
      break;
    case 'CompMedsList':
      output.append('Complete Medications History');
      break;
    case 'WhoHeightChart':
    case 'WhoWeightChart':
    case 'WhoHcChart':
    case 'CdcHeightChart':
    case 'CdcWeightChart':
    case 'CdcBmiChart':
    case 'CdcHcChart':
      output.append('Growth Chart');
      break;
    case 'MessageThread':
      output.append('Office Message');
      break;
    case 'Letter':
      output.append('Letter to ', (opt_data.isSendToPatient) ? 'Patient' : 'Provider');
      break;
    case 'LetterReceipt':
      output.append('Letter from ', soy.$$escapeHtml(opt_data.senderName));
      break;
    case 'PrenatalFlowsheet':
      output.append('Prenatal Flowsheet');
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.attachmentDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8AttachmentDescription">');
  el8.template.ptdata.letters.attachments.rawDescriptionText(opt_data, output);
  output.append('</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.rawDescriptionText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.modelClass) {
    case 'Report':
      el8.template.ptdata.reports.summary(opt_data, output);
      break;
    case 'ReferralOrder':
      el8.template.ptdata.model.order.referral.noteSummary(opt_data, output);
      break;
    case 'CardiacOrder':
    case 'ImagingOrder':
    case 'LabOrder':
    case 'SleepOrder':
    case 'PulmonaryOrder':
      el8.template.ptdata.model.order.orderNoteSummary(opt_data, output);
      break;
    case 'VisitNote':
      if (opt_data.isImportedNote) {
      } else {
        if (opt_data.problemBullets || opt_data.reasonBullets) {
          el8.template.ptdata.model.note.visitNoteHeaderSummary(opt_data, output);
        } else {
          output.append(soy.$$escapeHtml(opt_data.headerSummary));
        }
      }
      break;
    case 'NonvisitNote':
      break;
    case 'Handout':
      var tList19087 = opt_data.tags;
      var tListLen19087 = tList19087.length;
      for (var tIndex19087 = 0; tIndex19087 < tListLen19087; tIndex19087++) {
        var tData19087 = tList19087[tIndex19087];
        output.append(soy.$$escapeHtml(tData19087), (! (tIndex19087 == tListLen19087 - 1)) ? ', ' : '');
      }
      break;
    case 'MessageThread':
      el8.template.ptdata.model.message.letterSummary(opt_data, output);
      break;
    case 'Letter':
      el8.template.ptdata.letters.attachments.letterDescription(opt_data, output);
      break;
    case 'LetterReceipt':
      el8.template.ptdata.letters.attachments.letterReceiptDescription(opt_data, output);
      break;
    case 'RefPanel':
      output.append('Allergies, Drug Intolerances, Problem List, History, Permanent Rx Meds, ...');
      break;
    case 'PatientDemog':
      output.append('Address, Insurance Info, etc.');
      break;
    case 'ImmHistory':
      output.append('CDC Vaccine Schedule and other vaccinations (from LHS)');
      break;
    case 'MedsList':
      output.append('Current Medications (from LHS)');
      break;
    case 'CompMedsList':
      output.append('Current, temporary, and discontinued medications (from Meds Hx)');
      break;
    case 'WhoHeightChart':
      output.append('WHO Height for Age (0-2 yrs)');
      break;
    case 'WhoWeightChart':
      output.append('WHO Weight for Age (0-2 yrs)');
      break;
    case 'WhoHcChart':
      output.append('WHO HC for Age (0-2 yrs)');
      break;
    case 'CdcHeightChart':
      output.append('CDC Height for Age (2-20 yrs)');
      break;
    case 'CdcWeightChart':
      output.append('CDC Weight for Age (2-20 yrs)');
      break;
    case 'CdcBmiChart':
      output.append('CDC BMI for Age (2-20 yrs)');
      break;
    case 'CdcHcChart':
      output.append('CDC HC for Age (2-3 yrs)');
      break;
    case 'PrenatalFlowsheet':
      el8.template.ptdata.letters.attachments.flowsheetDescription(opt_data, output);
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.flowsheetDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.name), ' - EDD: ', soy.$$escapeHtml(opt_data.edd));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.pageCountShort = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.count), ' pg');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.pageCountFull = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.count), (opt_data.count == opt_data.UPPER_BOUND) ? '+' : '', ' ', (opt_data.count == 1) ? 'page' : 'pages');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.letterDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.isSendToPatient) ? 'To: ' + soy.$$escapeHtml(opt_data.displayTo) + ((opt_data.subject || opt_data.body) ? ', ' : '') : '', (opt_data.subject) ? 're: ' + soy.$$escapeHtml(opt_data.subject) : (opt_data.body) ? soy.$$escapeHtml(opt_data.body.substring(0,50)) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letters.attachments.letterReceiptDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.subject) ? 're: ' + soy.$$escapeHtml(opt_data.subject) : (opt_data.body) ? soy.$$escapeHtml(opt_data.body.substring(0,50)) : '');
  if (!opt_sb) return output.toString();
};
